import api from './api';
import type { CrmPipeline, CrmPipelineCreate } from '../types/crm';

const crmPipelineService = {
  getAll: async (): Promise<CrmPipeline[]> => {
    const response = await api.get<CrmPipeline[]>('/api/CrmPipelines');
    return response.data;
  },

  getById: async (id: number): Promise<CrmPipeline> => {
    const response = await api.get<CrmPipeline>(`/api/CrmPipelines/${id}`);
    return response.data;
  },

  create: async (dto: CrmPipelineCreate): Promise<CrmPipeline> => {
    const response = await api.post<CrmPipeline>('/api/CrmPipelines', dto);
    return response.data;
  },

  update: async (id: number, dto: CrmPipelineCreate): Promise<CrmPipeline> => {
    const response = await api.put<CrmPipeline>(`/api/CrmPipelines/${id}`, dto);
    return response.data;
  },
};

export default crmPipelineService;
